import Vue from "vue";
import Vuex from "vuex";

import advisors from "@/store/advisors";
import auth from "@/store/auth";
import profile from "@/store/profile";
import updates from "@/store/updates";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    initialized: false,
  },
  mutations: {
    setInitialized(state, isInitialized) {
      state.initialized = isInitialized;
    },
  },
  actions: {
    async init({ dispatch, commit, state }) {
      await dispatch("auth/init");
      commit("setInitialized", true);

      if (state.auth.signedIn) {
        dispatch("advisors/loadAndListen");
        dispatch("profile/loadAndListen");
      }
    },
  },
  modules: {
    advisors,
    auth,
    profile,
    updates,
  },
});
